<template>
  <InfoModal title="Material info" @primaryButtonClicked="emit('close')">
    <template #content>
      <div class="flex flex-col">
        <div class="w-full p-2 m-2 ml-0 rounded-md bg-cyan-light text-theme-600">
          {{ material?.code }} - {{ material?.name }}
        </div>
        <div class="flex justify-between">
          <div>
            <div><span class="font-medium">Type:</span> {{ materialType || '-' }}</div>
            <div>
              <span class="font-medium">VatCategory: </span>{{ material.vatCategory?.name || '-' }}
            </div>
          </div>
          <div class="flex justify-center mx-auto">
            <img
              v-if="materialImage"
              :src="materialImage"
              alt="Product Image"
              class="w-auto h-48 rounded-md" />
          </div>
        </div>
      </div>
    </template>
  </InfoModal>
</template>

<script setup lang="ts">
import InfoModal from '@/components/common/InfoModal.vue';
import type { SelectDropdownItem } from '@/types/Base';
import type { Material } from '@/types/Materials';
import { onMounted, ref } from 'vue';

const props = defineProps<{
  open: boolean;
  material: Material;
  materialTypes: SelectDropdownItem[];
}>();

const emit = defineEmits(['close']);

const materialType = ref<string>('');

const materialImage = ref<string>('');

onMounted(async () => {
  if (props.material.materialType && props.materialTypes) {
    const selectValue = props.materialTypes.find(
      (item) => item.value == props.material.materialTypeId
    );
    if (selectValue) materialType.value = selectValue.name;
  }
  if (props.material.image) materialImage.value = `data:image/jpeg;base64,${props.material.image}`;
});
</script>
